import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { DotsIndicator } from "../dots-indicator-onboarding/dots-indicator-onboarding";

interface BigModalOnboardingProps {
  title: string;
  subTitle: string;
  description: string;
  buttonText: string;
  handleNextPage: () => void;
  handleSkip: () => void;
}

export const BigModalOnboarding = ({
  title,
  subTitle,
  description,
  buttonText,
  handleNextPage,
  handleSkip,
}: BigModalOnboardingProps) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isLandscape = useMediaQuery(
    "(orientation: landscape) and (max-width: 1366px)",
  );
  const isCompactLandscape = useMediaQuery(
    "(orientation: landscape) and (max-width: 1366px)",
  );
  const isCompact = isCompactLandscape || isMobile;

  return (
    <Box
      sx={{
        background: "#FFFFFF",
        paddingX: isCompact
          ? isLandscape
            ? { xs: "24px", sm: "28px", md: "36px" }
            : { xs: "16px", sm: "20px", md: "28px" }
          : { xs: "28px", sm: "28px", md: "64px" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: isLandscape ? "min(92vw, 760px)" : "620px",
        borderRadius: "40px",
        maxHeight: "830px",
        marginX: { xs: "8px", sm: "18px", md: "40px" },
        marginBottom: { xs: "8px", sm: "18px", md: "0" },
        paddingY: isCompact
          ? isLandscape
            ? { xs: "18px", sm: "20px", md: "16px" }
            : { xs: "20px", sm: "24px", md: "12px" }
          : { xs: "56px", sm: "56px", md: "0" },
        height: { xs: "auto", sm: "auto", md: "100%" },
      }}
    >
      <Typography
        sx={{
          mb: isCompact ? "8px" : "12px",
          fontSize: isCompact
            ? isLandscape
              ? { xs: "36px", sm: "40px", md: "46px" }
              : { xs: "22px", sm: "26px", md: "34px" }
            : { xs: "32px", sm: "32px", md: "64px" },
          fontWeight: 700,
          textAlign: "center",
          maxWidth: "480px",
          lineHeight: "110.00000000000001%",
        }}
      >
        <Box component="span" sx={{ color: "#000" }}>
          {title}{" "}
        </Box>
        <Box
          component="span"
          sx={{
            background: "linear-gradient(90deg, #8957CF 0%, #28C9DC 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {subTitle}
        </Box>
      </Typography>

      <Typography
        sx={{
          mb: isCompact ? (isLandscape ? "20px" : "16px") : "40px",
          fontSize: isCompact
            ? isLandscape
              ? { xs: "14px", sm: "15px", md: "16px" }
              : { xs: "12px", sm: "13px", md: "14px" }
            : { xs: "16px", sm: "16px", md: "18px" },
          textAlign: "center",
          color: "#84909F",
          fontWeight: 600,
          maxWidth: { xs: "250px", sm: "250px", md: "305px" },
        }}
      >
        {description}
      </Typography>

      <Box
        sx={{
          width: "100%",
          maxWidth: { xs: "260px", sm: "300px", md: "200px" },
        }}
      >
        <Button
          onClick={handleNextPage}
          sx={{
            background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
            color: "#FFFFFF",
            textTransform: "none",
            fontWeight: "bold",
            borderRadius: "999px",
            width: "100%",
            px: isCompact ? "18px" : "32px",
            py: isCompact ? (isLandscape ? "12px" : "9px") : "16px",
            mb: isCompact ? (isLandscape ? "18px" : "14px") : "40px",
            "&:hover": {
              background: "linear-gradient(90deg, #20B6C8 0%, #7C4ABF 100%)",
            },
          }}
        >
          {buttonText}
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          marginTop: { xs: "10px", sm: "12px" },
          marginBottom: { xs: "8px", sm: "10px" },
          paddingX: { xs: "8px", sm: "12px" },
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "30px" }} />
        <DotsIndicator activeIndex={0} />
        <Typography
          onClick={handleSkip}
          sx={{
            fontSize: { xs: "14px", sm: "16px" },
            color: "#B6BAD5",
            cursor: "pointer",
          }}
        >
          Skip
        </Typography>
      </Box>
    </Box>
  );
};
